import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnDestroy, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DropdownOption } from '@maced/angular-components/lib/dropdown/dropdown.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-list-card',
  templateUrl: './list-card.component.html',
  styleUrls: ['./list-card.component.scss']
})
export class ListCardComponent implements OnDestroy {
  showIconClass = true;
  withoutDragActions = false;
  title = 'Card Name';
  options: DropdownOption[] = [
    {
      id: 'option41',
      name: 'option41',
      label: 'option 41',
      url: '/dropdown'
    },
    {
      id: 'option42',
      name: 'option42',
      label: 'option 42',
      url: '/dropdown'
    },
    {
      id: 'option43',
      name: 'option43',
      label: 'option 43',
      url: '/dropdown'
    }
  ];
  labelList: any[] = [
    {
      label: 'Label',
      placeholder: 'Placeholder 1',
      icon: 'icon-plus-circle',
    },
    {
      placeholder: 'Placeholder 2',
    },
    {
      label: 'Label',
      placeholder: 'Placeholder 3',
    },
    {
      label: "Label",
      placeholder: 'Placeholder 4',
    },
    {
      label: "Label",
      placeholder: 'Placeholder 5',
      icon: 'icon-plus-circle'
    }
  ];

  isBrowser = true;
  private queryParamSubscription!: Subscription;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private route: ActivatedRoute
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    this.queryParamSubscription = this.route.queryParams.subscribe(param => {
      if (!this.isBrowser) {
        if (param.showIconClass) {
          this.showIconClass = param.showIconClass === 'on';
        } else {
          this.showIconClass = false;
        }
        if (param.withoutDragActions) {
          this.withoutDragActions = param.withoutDragActions === 'on';
        } else {
          this.withoutDragActions = false;
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.queryParamSubscription) {
      this.queryParamSubscription.unsubscribe();
    }
  }
}